"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Footer;
var _react = _interopRequireWildcard(require("react"));
var _Modal = _interopRequireDefault(require("react-bootstrap/Modal"));
var _CloseButton = _interopRequireDefault(require("react-bootstrap/CloseButton"));
var _Container = _interopRequireDefault(require("react-bootstrap/Container"));
var _Row = _interopRequireDefault(require("react-bootstrap/Row"));
var _Col = _interopRequireDefault(require("react-bootstrap/Col"));
var _axios = _interopRequireDefault(require("axios"));
var _Button = _interopRequireDefault(require("react-bootstrap/Button"));
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
require("./Footer.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */

function Footer() {
  const [showPatents, setShowPatents] = (0, _react.useState)(false);
  const handlePatentsClose = () => setShowPatents(false);
  const [showPaymentModal, setShowPaymentModal] = (0, _react.useState)(false);
  let date = new Date();
  let currentYear = date.getFullYear();
  const [footer, setFooter] = (0, _react.useState)(null);
  (0, _react.useEffect)(() => {
    const fetchFooter = async () => {
      try {
        const timestamp = Date.now();
        const url = "".concat(process.env.REACT_APP_CDN_FOOTER_JSON, "?timestamp=").concat(timestamp);
        const response = await _axios.default.get(url);
        setFooter(response.data);
      } catch (error) {
        console.error("Error fetching footer:", error);
      }
    };
    fetchFooter();
  }, []);
  const handlePaymentModalShow = () => {
    setShowPaymentModal(true);
  };
  const handlePaymentModalClose = () => {
    setShowPaymentModal(false);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("footer", null, footer && /*#__PURE__*/_react.default.createElement(_Container.default, null, /*#__PURE__*/_react.default.createElement(_Row.default, {
    className: "footer-row"
  }, /*#__PURE__*/_react.default.createElement(_Col.default, {
    sm: 12,
    md: 12,
    lg: 4,
    xl: 4
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cell-logo"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: footer.celligenceLogoInfo.url,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: footer.celligenceLogoInfo.imgPath,
    className: "footer-cell-logo",
    alt: footer.celligenceLogoInfo.alt,
    title: footer.celligenceLogoInfo.title,
    loading: "lazy"
  }))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
    className: "footer-para"
  }, footer.disclaimer.disclaimerText)), /*#__PURE__*/_react.default.createElement("div", {
    className: "copyright"
  }, "Copyright \xA9 ", currentYear, " Celligence International LLC. All rights reserved")), /*#__PURE__*/_react.default.createElement(_Col.default, {
    sm: 12,
    md: 12,
    lg: 4,
    xl: 3,
    className: "contact-col"
  }, /*#__PURE__*/_react.default.createElement("div", null, " ", /*#__PURE__*/_react.default.createElement("p", {
    className: "footer-head",
    id: "contactus-head"
  }, footer.contactUs.heading)), /*#__PURE__*/_react.default.createElement("div", {
    className: "contact-item"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: footer.contactUs.angelaiEmail.imgPath,
    className: "contact-icon",
    alt: footer.contactUs.angelaiEmail.alt,
    loading: "lazy"
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "mt-1"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: footer.contactUs.angelaiEmail.url,
    style: {
      color: "#FFF"
    }
  }, footer.contactUs.angelaiEmail.emailAddress))), /*#__PURE__*/_react.default.createElement("div", {
    className: "contact-item"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: footer.contactUs.phone.imgPath,
    className: "contact-icon",
    alt: footer.contactUs.phone.alt,
    loading: "lazy"
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "mt-1"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: footer.contactUs.phone.phoneNumberWithIntlCode,
    style: {
      color: "#FFF"
    }
  }, footer.contactUs.phone.phoneNumber))), /*#__PURE__*/_react.default.createElement("div", {
    className: "contact-item location"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("img", {
    src: footer.contactUs.address.imgPath,
    id: "address-icon",
    className: "contact-icon mt-1 width-40px",
    alt: "Address Icon",
    loading: "lazy"
  })), /*#__PURE__*/_react.default.createElement("p", {
    className: "mt-3 desktop"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: footer.contactUs.address.addressMapUrl,
    target: "_blank",
    rel: "noreferrer"
  }, (0, _htmlReactParser.default)(footer.contactUs.address.fullAddress))), /*#__PURE__*/_react.default.createElement("p", {
    className: "mt-3 mobile"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: footer.contactUs.address.addressMapUrl,
    target: "_blank",
    rel: "noreferrer"
  }, (0, _htmlReactParser.default)(footer.contactUs.address.fullAddressMobile)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "socialmedia mb-3"
  }, footer.socialMedia.map((socialMediaLinksData, i) => /*#__PURE__*/_react.default.createElement("a", {
    key: i,
    href: socialMediaLinksData.url,
    target: "_blank",
    rel: "noreferrer",
    title: socialMediaLinksData.title
  }, /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement("div", null, "Loading...")
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: socialMediaLinksData.imgPath,
    alt: socialMediaLinksData.alt,
    className: "social-icon",
    loading: "lazy"
  })))))), /*#__PURE__*/_react.default.createElement(_Col.default, {
    sm: 12,
    md: 12,
    xl: 3,
    lg: 3,
    className: "last-col"
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "imp",
    className: "footer-head"
  }, footer.importantLinks.heading), /*#__PURE__*/_react.default.createElement("div", {
    className: "links-mobile"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: footer.importantLinks.privacyPolicy.privacyPolicyUrl,
    target: "_blank",
    rel: "noreferrer"
  }, " ", /*#__PURE__*/_react.default.createElement("div", {
    className: "link",
    style: {
      color: "#FFF"
    }
  }, footer.importantLinks.privacyPolicy.privacyPolicyName)), /*#__PURE__*/_react.default.createElement("div", {
    className: "link",
    id: "patent",
    onClick: handlePaymentModalShow,
    style: {
      color: "#FFF"
    }
  }, footer.importantLinks.patent.patentName), /*#__PURE__*/_react.default.createElement(_Modal.default, {
    show: showPaymentModal,
    onHide: handlePaymentModalClose,
    size: "lg",
    className: "mt-5 "
  }, /*#__PURE__*/_react.default.createElement(_Modal.default.Header, {
    className: "patent justify-content-start patent-modal"
  }, /*#__PURE__*/_react.default.createElement(_Modal.default.Title, null, "Patents Owned by Celligence")), /*#__PURE__*/_react.default.createElement(_Modal.default.Body, {
    className: "patent-modal",
    style: {
      backgroundColor: "FFF"
    }
  }, /*#__PURE__*/_react.default.createElement("ul", null, footer.importantLinks.patent.patentList.map((patent, index) => /*#__PURE__*/_react.default.createElement("li", {
    key: index
  }, patent)))), /*#__PURE__*/_react.default.createElement(_Modal.default.Footer, {
    className: "mb-5"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: handlePaymentModalClose
  }, "Close"))), /*#__PURE__*/_react.default.createElement("a", {
    href: footer.importantLinks.termsOfUse.termsUrl,
    target: "_blank",
    rel: "noreferrer",
    style: {
      color: "#FFF"
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pb-4 link"
  }, footer.importantLinks.termsOfUse.termsName))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("a", {
    href: footer.siteMap.sitemapCelligenceUrlAnother,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "footer-head"
  }, footer.siteMap.heading)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "companyAwards"
  }, footer.companyAwards.map(award => /*#__PURE__*/_react.default.createElement("a", {
    href: award.url,
    target: "_blank",
    rel: "noreferrer",
    title: award.title,
    key: award.name
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: award.imgPath,
    className: "bestbiz",
    alt: award.alt,
    title: award.title,
    loading: "lazy"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "copyright-mobile mb-4"
  }, "Copyright \xA9 ", currentYear, " Celligence International LLC. All rights reserved")), /*#__PURE__*/_react.default.createElement(_Modal.default, {
    id: "modPatent",
    centered: true,
    show: showPatents,
    onHide: handlePatentsClose,
    backdrop: "static"
  }, /*#__PURE__*/_react.default.createElement(_Modal.default.Header, null, /*#__PURE__*/_react.default.createElement("h4", null, "Patents Owned by Celligence"), " ", /*#__PURE__*/_react.default.createElement(_CloseButton.default, {
    onClick: handlePatentsClose
  })), /*#__PURE__*/_react.default.createElement(_Modal.default.Body, {
    className: "pb-0"
  }, /*#__PURE__*/_react.default.createElement("ul", null, footer.importantLinks.patent.patentList.map((patent, index) => /*#__PURE__*/_react.default.createElement("li", {
    key: index
  }, patent)))))), " "));
}